import React from 'react';
import {
  View, Text, StyleSheet,
  ActivityIndicator,
} from 'react-native';
import Colors from '../../../constants/Colors';
import UserIcon24 from '../../../components/24pxIcons/UserIcon24';
import CloseIconSmall from '../../../components/12pxIcons/CloseIconSmall';
import PressableStyled from '../../../components/PressableStyled';
import isMobile from '../../../components/IsMobile';
import SelectionModal from '../../../components/SelectionModal';
import ChangeGroupList from '../../../components/AssetManagement/AddTemplateModal/components/IssueList/components/IssueRow/components/ChangeGroupList';

interface TicketGroupTagProps {
  groupId: string,
  userGroups,
  deleteAction?: () => void,
  tags?: string[],
  tagSelected?: boolean,
  itemIndex?: number,
  // eslint-disable-next-line no-unused-vars
  setTagDropdownShownIndex?: (index: number) => void,
  // eslint-disable-next-line no-unused-vars
  addGroup?: (updatedTags: string[]) => void,
  saving?: boolean,
}

const TicketGroupTag = ({
  groupId, userGroups, deleteAction, addGroup,
  tags, tagSelected, itemIndex, setTagDropdownShownIndex, saving,
}: TicketGroupTagProps) => {
  const groupName = userGroups?.filter((group) => group.UserGroupId === groupId)[0]?.Name ?? '-';
  return groupName && <View style={styles.container}>
    <UserIcon24 />
    <Text style={styles.name}>{groupName}</Text>
    {deleteAction && <PressableStyled onPress={() => deleteAction()}>
      <CloseIconSmall />
    </PressableStyled>}
    {isMobile ? <SelectionModal
      listContent={<ChangeGroupList
        {...{ userGroups, tags, itemIndex }}
        update={(userGroupId: string) => {
          const updatedTags: string[] = tags ?? [];
          updatedTags[itemIndex] = userGroupId;
          addGroup(updatedTags);
          setTagDropdownShownIndex(-1);
        }}
        groups={userGroups}
      />}
      title='Select user group'
      isVisible={tagSelected}
      hide={() => setTagDropdownShownIndex(-1)}
    /> : null}
    {saving && <View style={{
      position: 'absolute', backgroundColor: Colors.light.hereworksDarkBlue, ...StyleSheet.absoluteFillObject, alignItems: 'center', justifyContent: 'center', borderRadius: 6,
    }}>
      <ActivityIndicator color={Colors.light.plainBackground} size={15} />
    </View>}
  </View>;
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Colors.light.hereworksDarkBlue,
    borderRadius: 6,
    paddingHorizontal: 4,
    flexShrink: 1,
  },
  name: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    color: '#fff',
    padding: 4,
  },
});

export default TicketGroupTag;
